import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";

const EMPTY = { service: "driveways", title: "", before_label: "Before", after_label: "After", before_url: "", after_url: "" };

export default function GalleryTab({ gallery, services, reload }) {
  const [form, setForm] = useState(EMPTY);
  const input = "w-full bg-[#070b12] border border-white/15 rounded-xl px-4 py-2.5 text-sm text-white focus:border-[#1e9bff] outline-none";

  const add = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/gallery", form);
      toast.success("Before/after added");
      setForm(EMPTY);
      reload();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  const remove = async (id) => {
    try {
      await api.delete(`/admin/gallery/${id}`);
      toast.success("Removed");
      reload();
    } catch (err) {
      toast.error(apiError(err));
    }
  };

  return (
    <div className="space-y-6" data-testid="gallery-tab">
      <form onSubmit={add} className="p-5 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20 space-y-3" data-testid="gallery-add-form">
        <h3 className="font-display uppercase text-lg text-white">Add Before / After</h3>
        <p className="text-[11px] text-[#627d98] font-mono-lbl">Paste image URLs for now — direct photo upload is coming soon.</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <input required placeholder="Title (e.g. Driveway, S11)" className={input} data-testid="gallery-title-input"
            value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} />
          <select className={input} value={form.service} data-testid="gallery-service-select"
            onChange={(e) => setForm({ ...form, service: e.target.value })}>
            {services.map((s) => <option key={s.slug} value={s.slug}>{s.name}</option>)}
          </select>
          <input required placeholder="Before image URL" className={input} data-testid="gallery-before-input"
            value={form.before_url} onChange={(e) => setForm({ ...form, before_url: e.target.value })} />
          <input required placeholder="After image URL" className={input} data-testid="gallery-after-input"
            value={form.after_url} onChange={(e) => setForm({ ...form, after_url: e.target.value })} />
          <input placeholder="Before label" className={input} value={form.before_label}
            onChange={(e) => setForm({ ...form, before_label: e.target.value })} />
          <input placeholder="After label" className={input} value={form.after_label}
            onChange={(e) => setForm({ ...form, after_label: e.target.value })} />
        </div>
        <button type="submit" data-testid="gallery-add-btn"
          className="px-6 py-2.5 rounded-xl bg-[#1e9bff] text-black text-xs font-bold uppercase tracking-wider hover:bg-[#60baff] transition-colors">
          Add to Gallery
        </button>
      </form>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {gallery.map((g) => (
          <article key={g.id} className="p-4 rounded-2xl bg-[#0b1322] border border-[#1e9bff]/20" data-testid={`gallery-item-${g.id}`}>
            <div className="flex gap-2 mb-3">
              <img src={g.before_url} alt="" className="w-1/2 h-20 object-cover rounded-lg" loading="lazy" />
              <img src={g.after_url} alt="" className="w-1/2 h-20 object-cover rounded-lg" loading="lazy" />
            </div>
            <p className="text-sm text-white mb-1">{g.title}</p>
            <p className="text-[10px] font-mono-lbl text-[#627d98] uppercase mb-3">{g.service}{g.sample ? " · sample" : ""}</p>
            <button onClick={() => remove(g.id)} data-testid={`gallery-delete-${g.id}`}
              className="px-4 py-1.5 rounded-lg bg-red-500/15 border border-red-500/40 text-red-400 text-xs font-mono-lbl uppercase hover:bg-red-500/25 transition-colors">
              Delete
            </button>
          </article>
        ))}
      </div>
    </div>
  );
}
